class More {

	constructor(){  
    this.component = document.querySelector('[data-component="more"]');
    
    if(this.component){
      this.trigger = this.component.querySelector('[data-trigger="more"]');
      this.target = this.component.querySelector('[data-target="more"]');
      this.minimalHeight = 37;
      this._init();
    }
	}

	_init(){
    this.originalHeight = this.target.offsetHeight;
    this.trigger.setAttribute('data-state', 'closed');

    if(this.originalHeight <= this.minimalHeight){
      this.trigger.setAttribute('data-state', 'hide');
    }else{
      this.target.setAttribute('data-state', 'excerpt');      
      this.trigger.addEventListener('click', (event)=> this._showAllText(event) );
    }
  }
  
  _showAllText(event){

    if (this.trigger.getAttribute('data-state') == 'closed') {
      this.target.style.height = this.originalHeight + 'px';
      this.target.setAttribute('data-state', 'all');
      //this.trigger.setAttribute('data-state', 'hide');
  
      this.trigger.setAttribute('data-state', 'open');
      this.trigger.innerHTML = '> R&eacute;duire';
    }
    else {
      this.target.style.height = this.minimalHeight + 'px';
      this.target.setAttribute('data-state', 'excerpt');
      this.trigger.setAttribute('data-state', 'closed');
      this.trigger.innerHTML = '> lire la suite';
    }
  }
  
}

export const more = new More();